angular.module('invoice')
    .controller('InvoiceSettingsController', function ($uibModalInstance, Invoice, InvoiceService) {
        this.$onInit = () => {
            Invoice.statuses().$promise.then(items => this.statuses = items)
            Invoice.settings().$promise.then(item => this.item = item)
        }
        this.duplicateStatusSet = $index => {
            let item = {
                users: this.item.statusSettings[$index].users
            }
            this.item.statusSettings.push(angular.copy(item))
        }
        this.duplicateCustomerSet = $index => {
            let item = {
                users: this.item.customerSettings[$index].users
            }
            this.item.customerSettings.push(angular.copy(item))
        }
        this.close = () => $uibModalInstance.dismiss()
        this.save = () => {
            Invoice.saveSettings(this.item).$promise.then(() => $uibModalInstance.close())
        }
    })
